module.exports = __webpack_public_path__ + "img/data-breach.cde197cd.png";